import React from "react";
import { func } from "prop-types";
import { push } from "react-router-redux";
import FontAwesome from "react-fontawesome";
import NewFeatureNotificationModal from "components/NewFeatureNotificationModal";

const NewCriteriaBatteryNotification = ({
  dismissNewCriteriaBatteryNotification,
  dispatch,
}) => {
  const modalName = "new test batteries notification";

  const navigateToJobs = () => {
    window.analytics.track("modal clicked", {
      "modal name": modalName,
    });
    dispatch(push("/jobs"));
  };

  const navigateToManageTestBatteries = () => {
    window.analytics.track("modal clicked", {
      "modal name": modalName,
    });
    dispatch(push("/testbatteries"));
  };

  const newCriteriaBatteryNotificationContent = (
    <div className="mt-2 ml-4 mr-2 mb-2 px-2" style={{ color: "#828283" }}>
      Based on new data and the addition of new and updated assessments, our
      team of experts have updated recommended test batteries for certain jobs.
      Look for the
      <span>
        <div className="updateTestBatteryDropdownItemAlert mx-1">
          <FontAwesome
            name="exclamation"
            fixedWidth
            style={{ marginLeft: "1px" }}
          />
        </div>
      </span>
      icon in{" "}
      <span>
        {" "}
        <button
          type="button"
          className="btn-as-link"
          style={{ color: "#828283", fontWeight: "bold" }}
          onClick={navigateToJobs}
        >
          Jobs
        </button>
      </span>{" "}
      and/or{" "}
      <span>
        <button
          type="button"
          className="btn-as-link"
          style={{
            color: "#828283",
            fontWeight: "bold",
          }}
          onClick={navigateToManageTestBatteries}
        >
          {"Manage > Test Batteries"}
        </button>
      </span>
      .
    </div>
  );

  return (
    <NewFeatureNotificationModal
      dismissNotification={dismissNewCriteriaBatteryNotification}
      cardClassName="newCriteriaBatteryNotification"
      notificationContent={newCriteriaBatteryNotificationContent}
      notificationTitle="New Criteria Test Batteries are Available"
      modalName={modalName}
    />
  );
};

NewCriteriaBatteryNotification.propTypes = {
  dismissNewCriteriaBatteryNotification: func.isRequired,
  dispatch: func.isRequired,
};

export default NewCriteriaBatteryNotification;
